module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "Head"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Arvonia Elizabeth Vaughn, Great Falls, Montana.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("My Dear Little Daughter:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The following series of letters, which include a short history of Montana’s early days, together with a brief sketch of your father’s life and a copy of my letter to you, giving an obituary of your dear mother, I dedicate to you, knowing that they will be appreciated, and hoping that you will have the pleasure of reading them after I am gone.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Your affectionate father,")]), _vm._v(" "), _c('p', {
    staticClass: "Rightpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERRT")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUGHN")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Rightpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAT")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALLS")]), _vm._v(", M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTANA")]), _vm._v(", M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AY")]), _vm._v(" 15"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TH")]), _vm._v(", 1900")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d68449","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_ThenandNowbook_dedication.vue
// module id = 63
// module chunks = 0